<template>
    <validation-observer  ref="Command">
        <form class="formBox">
            <validation-provider name="Şifre" :rules="{ required: true}" v-slot="validationContext">
                 <b-form-group class="inputGrp">
                    <b-row>
                        <b-col sm="4"> <label for="password"> Panel Şifresi </label> </b-col>
                        <b-col sm="8"> 
                            <b-form-input id="password" type="password" v-model="password" placeholder="Panel Şifresi" :state="getValidationState(validationContext)" />
                            <b-form-invalid-feedback id="live-feedback" style="display: block; width: 100%">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-col>
                    </b-row>
                </b-form-group>
            </validation-provider>
        </form>
    </validation-observer>
</template>

<style lang="css" scoped > 
    @import "../styles/add.min.css"; 
</style>

<script>
    export default {
        name: "Zone",
        created: async function(){
            await  this.$store.dispatch('getDeviceType')
        },
        data: function() {
            return {
                modalOpen: false,
                modalProps: {},
                currentForm:"Camera",
                modalType: "",
                password: ''
            }
        },
        props: {
            data: Object,
            save: Boolean,
            saveState: Function,
            modalEvent: Function,
            modalName: String
        },
        methods:{
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
        },
       
        watch: {
            data: function(){
                this.device_id = null
                this.type = null
                this.name = null
            },
            save: function(data){
                if(data){
                    this.$refs.Command.validate().then( async (success) =>{
                        if(success){
                            let data = {
                                command: this.data.cmd,
                                ispart: false,
                                partno: 0,
                                password: this.password,
                                id: this.data.device.id
                            }
                            await this.$store.dispatch('sendCommandDevice', data)
                            if(this.$store.getters.getAccountStatus.status == "Success"){
                                console.log(this.$store.getters.getAccountStatus, this.data.cmd)
                                if(this.$store.getters.getAccountStatus.data.answer == 'OK'){
                                    switch(this.data.cmd ){
                                        case "ARM":
                                            var audio = new Audio(require('../../../../assets/sound/arm.mp3'));
                                            break;
                                        case "DISARM":
                                            var audio = new Audio(require('../../../../assets/sound/disarm.mp3'));
                                            break;
                                        case "STAYARM":
                                            var audio = new Audio(require('../../../../assets/sound/stayarm.mp3'));
                                            break;
                                    }
                                    audio.play();
                                }
                                this.saveState(false)
                                this.modalEvent(false)
                                this.password = null
                            }else{
                                this.errMsg = this.$store.getters.getAccountStatus.message
                            }
                        }
                        }
                    )
                }
                this.saveState(false)

            }
        }
        
    }
</script>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/modals/Command.vue